<template>
  <div
    :class="typeClass"
    class="flex-center-between rounded-xl backdrop-blur min-w-[355px] p-3 toast"
  >
    <div class="flex-y-center mr-5">
      <img :alt="type" :src="images[type]" />

      <div class="ml-2">
        <h2 class="text-white font-semibold text-sm leading-130">
          {{ title }}
        </h2>
      </div>
    </div>

    <span
      :class="{
        'text-white': type === 'error',
      }"
      class="icon-close my-4 text-lg text-dark cursor-pointer transition-300"
      @click="closeToast"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useCustomToast } from "@/composables/useCustomToast";

interface Props {
  type: "success" | "error" | "warning" | "info";
  title: string;
  id: string;
}

const props = defineProps<Props>();

const { dismissToast } = useCustomToast();

const typeClass = computed(() => {
  return {
    "bg-[#1EC374]": props.type === "success",
    "bg-red": props.type === "error",
    "bg-yellow-500": props.type === "warning",
    "bg-blue-500": props.type === "info",
  };
});

const images = computed(() => {
  return {
    success: "/svg/toast/success.svg",
    error: "/svg/toast/error.svg",
    warning: "/svg/toast/warning.svg",
    info: "/svg/toast/info.svg",
  };
});

function closeToast() {
  dismissToast(props.id);
}
</script>

<style>
.toast {
  box-shadow: 0 4px 24px 0 rgba(220, 53, 69, 0.25);
}
</style>
